import React from 'react';
import { useInView } from "react-intersection-observer";
import "./Achievement.css"
export default function Achievement(){
      const { ref:myRef, inView:isVisible } = useInView();

    return(
<>
<div className="contercontent" id='contercontent'>

  <div className="counterbox one">
    <div className="information">
      <div className={isVisible ? "number fade-in" : "number"} ref={myRef}>
        <p id="big-number">10+</p>
      </div>
      <div className="text">
        <p id="big-text">Years <br />Crafting</p>
      </div>
    </div>
  </div>

  <div className="counterbox">
    <div className="information" data-aos="fade-down">
      <div className={isVisible ? "number fade-in" : "number"} ref={myRef}>
        <p>5K+</p>
      </div>
      <div className="text">
        <p>Furniture <br />Pieces Sold</p>
      </div>
    </div>
  </div>

  <div className="counterbox">
    <div className="information" data-aos="fade-down">
      <div className={isVisible ? "number evaluate" : "number"} ref={myRef}>
        <p>3K+</p>
      </div>
      <div className="text">
        <p>Happy <br />Clients</p>
      </div>
    </div>
  </div>

  <div className="counterbox">
    <div className="information" data-aos="fade-down">
      <div className={isVisible ? "number fade-in" : "number"} ref={myRef}>
        <p>200+</p>
      </div>
      <div className="text">
        <p>Custom <br />Designs</p>
      </div>
    </div>
  </div>

</div>

</>
    )
}